import { useTransactionContext } from '@/context/TransactionContext';

export const isDiamondStoneType = (itemType) => {
  const type = itemType?.toLowerCase?.();
  return type === 'diamond' || type === 'stone';
};

export const rowItemType = (row) =>
  row?.itemTypeName ||
  row?.itemType ||
  row?.typeName ||
  row?.finalData?.detailsJson?.[0]?.itemType;

export const isDiamondStoneRow = (row) => isDiamondStoneType(rowItemType(row));

export const useDiamondStoneModal = () => {
  const {
    openDiamondStoneOnly,
    setOpenDiamondStoneOnly,
    setDiamondCodeWindowId,
    setDiamondCodeWindowOptions,
  } = useTransactionContext();

  const openDiamondStone = (rowId, option = {}) => {
    setDiamondCodeWindowId(rowId ?? null);
    setDiamondCodeWindowOptions({
      value: option?.value,
      itemName: option?.itemName,
      itemType: option?.itemType,
    });
    setOpenDiamondStoneOnly(true);
  };

  const openDiamondStoneForRow = (row) =>
    openDiamondStone(row?.id || row?.codeWindowId, {
      value: row?.item || row?.itemId,
      itemName: row?.itemName,
      itemType: rowItemType(row),
    });

  const closeDiamondStone = () => setOpenDiamondStoneOnly(false);

  return {
    openDiamondStoneOnly,
    openDiamondStone,
    openDiamondStoneForRow,
    closeDiamondStone,
  };
};
